export const newLicenseList = {
  Ethiopian: [
    {
      name: "Residence Id",
      tooltip: "",
    },
    {
      name: "Medical Certificate",
      tooltip: "Taken within the last 3 months",
    },
    {
      name: "COC Certificate",
      tooltip: "Only for diploma graduates",
    },
    {
      name: "8th, 10th, 12th Grade Certificate",
      tooltip: "",
    },
    {
      name: "Academic Document",
      tooltip: "Diploma,transcript for both undergraduates and postgraduates",
    },
    {
      name: "Authenticated Professional License",
      tooltip: "",
    },
    {
      name: "9th - 10th Grade Transcript",
      tooltip: "",
    },

    {
      name: "11th - 12th Grade Transcript",
      tooltip: "",
    },

    {
      name: "Payroll Document",
      tooltip: "For Non-government Institutions",
    },

    {
      name: "Support Letter from Sponsored Institution",
      tooltip: "For those who upgraded by the sponsorship of an institution",
    },

    {
      name: "Work Experience",
      tooltip: "",
    },
    {
      name: "Academic Transcript",
      tooltip: "Non-government Institutions",
    },
  ],

  Foreigners: [
    {
      name: "Passport",
      tooltip: "",
    },
    {
      name: "Medical Certificate",
      tooltip: "Taken within the last 3 months",
    },
    {
      name: "English Language Proficiency Certificate",
      tooltip: "For non english speaking countries only",
    },
    {
      name: "Higher Education Relevance and Quality Agency Letter",
      tooltip: "Equivalence letter",
    },
    {
      name: "Authenticated Academic Document",
      tooltip: "Diploma,transcript for both undergraduates and postgraduates",
    },
    {
      name: "Authenticated Professional License from Country of Origin",
      tooltip: "",
    },
    {
      name: "Current Work Experience / Goodstanding Letter",
      tooltip: "More than two years",
    },

    {
      name: "Request Letter from Hiring Health Facility",
      tooltip: "Found in ethiopia",
    },
  ],

  EthiopianFromAbroad: [
    {
      name: "Residence ID or Passport or Yellow Card",
      tooltip: "Proof of Ethiopian decent",
    },
    {
      name: "Medical Certificate",
      tooltip: "Taken within the last 3 months",
    },
    {
      name: "English Language Proficiency Certificate",
      tooltip: "For non english speaking countries only",
    },
    {
      name: "Higher Education Relevance and Quality Agency Letter",
      tooltip: "Equivalence letter",
    },
    {
      name: "Authenticated Academic Document",
      tooltip: "Diploma,transcript for both undergraduates and postgraduates",
    },
    {
      name: "Authenticated Professional License from Country of Origin",
      tooltip: "",
    },
    {
      name: "Current Work Experience / Goodstanding Letter",
      tooltip: "More than two years",
    },

    {
      name: "Support Letter from Sponsored Institution",
      tooltip: "",
    },
  ],
};

export const renewalList = {
  Ethiopian: [
    {
      name: "Residence Id or Passport",
      tooltip: "",
    },
    {
      name: "Medical Certificate",
      tooltip: "Taken within the last 3 months",
    },
    {
      name: "Letter from Hiring Organization",
      tooltip: "Found in Ethiopia",
    },
    {
      name: "Previous License",
      tooltip: "",
    },
    {
      name: "CPD Certificate",
      tooltip: "",
    },
    {
      name: "Work Experience",
      tooltip: "More than two years",
    },
  ],

  Foreigners: [
    {
      name: "Passport",
      tooltip: "",
    },
    {
      name: "Medical Certificate",
      tooltip: "Taken within the last 3 months",
    },
    {
      name: "Letter from Hiring Organization",
      tooltip: "Found in Ethiopia",
    },
    {
      name: "Previous License",
      tooltip: "",
    },
    {
      name: "CPD Certificate",
      tooltip: "",
    },
    {
      name: "Work Experience",
      tooltip: "More than two years",
    },
  ],

  EthiopianFromAbroad: [
    {
      name: "Residence Id",
      tooltip: "",
    },
    {
      name: "Medical Certificate",
      tooltip: "Taken within the last 3 months",
    },
    {
      name: "Letter from Hiring Organization",
      tooltip: "Found in Ethiopia",
    },
    {
      name: "Previous License",
      tooltip: "",
    },
    {
      name: "CPD Certificate",
      tooltip: "",
    },
    {
      name: "Work Experience",
      tooltip: "More than two years",
    },
  ],
};

export const goodStandingList = [
  {
    name: "License Copy",
    tooltip: "",
  },
  {
    name: "Work Experience",
    tooltip: "",
  },
];

export const licenseDesignationList = [
  {
    name: "Senate letter",
    tooltip: "Support letter from the senate",
  },
  {
    name: "Support letter from the sponsoring institution",
    tooltip: "",
  },
];
export const lostLicenseList = [
  {
    name: "Police report",
    tooltip: "Official police report on the lost license",
  },
  {
    name: "Photo or copy of the lost license (Optional)",
    tooltip: "",
  },
];